import React, { useState, useEffect } from "react";
import "./BankMahiti.css";
import VarshikShillakForm from "./VarshikShillakForm";
import JamaKarnaryachiMahiti from "./JamaKarnaryachiMahiti";
import ChequeBookMahiti from "./ChequeBookMahiti";
import BankToBankTransfer from "./BankToBankTransfer";

const BankMahiti = () => {
  // Bank options dropdown data
  const bankOptions = [
    "स्टेट बँक ऑफ इंडिया (SBI)",
    "ICICI बँक",
    "HDFC बँक",
    "एक्सिस बँक",
    "बँक ऑफ इंडिया",
    "पंजाब नॅशनल बँक (PNB)",
    "बँक ऑफ बड़ौदा",
    "इंडियन बँक",
    "यूनियन बँक ऑफ इंडिया",
    "सेंट्रल बँक ऑफ इंडिया",
    "इंडियन ओव्हरसीज बँक",
    "विजया बँक",
    "कोऑपरेटिव्ह बँक",
    "इतर",
  ];

  const branchOptions = [
    "मुख्य शाखा",
    "शहर शाखा",
    "ग्रामीण शाखा",
    "उप-शाखा",
    "विशेष शाखा",
  ];

  const accountTypeOptions = [
    "बचत खाता",
    "चालू खाता",
    "सावधि खाता",
    "आवर्ती जमा",
    "डिजिटल वॉलेट",
    "सरकारी योजना खाता",
  ];

  // Default funds
  const defaultFunds = ["पानीपुरवठा निधि", "ग्राम निधि"];

  // Load data from localStorage on mount
  const [banks, setBanks] = useState(() => {
    const savedBanks = localStorage.getItem("grampanchayat_banks");
    return savedBanks ? JSON.parse(savedBanks) : [];
  });

  const [funds, setFunds] = useState(() => {
    const savedFunds = localStorage.getItem("grampanchayat_funds");
    return savedFunds ? JSON.parse(savedFunds) : defaultFunds;
  });

  const [showForm, setShowForm] = useState(false);
  const [searchBankName, setSearchBankName] = useState("");
  const [showFundForm, setShowFundForm] = useState(false);
  const [newFundName, setNewFundName] = useState("");
  const [formData, setFormData] = useState({
    fundName: "",
    bankName: "",
    branchName: "",
    accountType: "",
    accountNumber: "",
    ifscCode: "",
    address: "",
    openingBalance: "",
  });

  // Save banks to localStorage whenever banks array changes
  useEffect(() => {
    localStorage.setItem("grampanchayat_banks", JSON.stringify(banks));
  }, [banks]);

  // Save funds to localStorage whenever funds array changes
  useEffect(() => {
    localStorage.setItem("grampanchayat_funds", JSON.stringify(funds));
  }, [funds]);

  const handleAddFund = (e) => {
    e.preventDefault();
    if (!newFundName.trim()) {
      alert("❌ निधि नाव खाली असू शकत नाही!");
      return;
    }

    if (funds.includes(newFundName)) {
      alert("⚠️ हा निधि आधीच जोडला गेला आहे!");
      return;
    }

    setFunds([...funds, newFundName]);
    setNewFundName("");
    alert("✅ निधि यशस्वीरित्या जोडला गेला!");
    setShowFundForm(false);
  };

  const deleteFund = (fundToDelete) => {
    if (defaultFunds.includes(fundToDelete)) {
      alert("⚠️ डिफॉल्ट निधि हटवता येत नाही!");
      return;
    }
    setFunds(funds.filter((f) => f !== fundToDelete));
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.bankName || !formData.fundName || !formData.accountType) {
      alert("❌ फंड नाव, बँक नाव व खाते प्रकार आवश्यक आहे!");
      return;
    }

    setBanks([...banks, { ...formData, id: Date.now() }]);

    setFormData({
      fundName: "",
      bankName: "",
      branchName: "",
      accountType: "",
      accountNumber: "",
      ifscCode: "",
      address: "",
      openingBalance: "",
    });

    alert("✅ बँक यशस्वीरित्या जोडले गेले!");
    setShowForm(false);
  };

  const deleteBank = (id) => {
    const updated = banks.filter((bank) => bank.id !== id);
    setBanks(updated);
  };

  const handleReset = () => {
    setFormData({
      fundName: "",
      bankName: "",
      branchName: "",
      accountType: "",
      accountNumber: "",
      ifscCode: "",
      address: "",
      openingBalance: "",
    });
  };

  return (
    <div className="bank-container">
      {/* HEADER */}
      <div className="bank-header">
        <h2 className="bank-title">🏦 बँकची माहिती</h2>
        <button
          className="bank-btn-toggle"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? "✕ बंद करा" : "➕ नवीन बँक"}
        </button>
      </div>

      {/* FUND INFO SECTION */}
      <div className="bank-fund-section">
        <div className="fund-header">
          <h3>💰 निधी व्यवस्थापन</h3>
          <button
            className="bank-btn-toggle"
            onClick={() => setShowFundForm(!showFundForm)}
            style={{ marginTop: 0 }}
          >
            {showFundForm ? "✕ बंद करा" : "➕ नवीन निधि"}
          </button>
        </div>

        {showFundForm && (
          <form onSubmit={handleAddFund} className="fund-form">
            <div className="fund-form-group">
              <input
                type="text"
                placeholder="निधि नाव टाका..."
                value={newFundName}
                onChange={(e) => setNewFundName(e.target.value)}
                className="bank-input"
                required
              />
              <button type="submit" className="bank-btn-save">
                ➕ जोडा
              </button>
            </div>
          </form>
        )}

        <div className="funds-list">
          {funds.map((fund) => (
            <div key={fund} className="fund-item">
              <span className="fund-name">💵 {fund}</span>
              {!defaultFunds.includes(fund) && (
                <button
                  className="fund-delete-btn"
                  onClick={() => deleteFund(fund)}
                  title="हटवा"
                >
                  ✕
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* SEARCH FILTER */}
      <div className="bank-search-section">
        <input
          type="text"
          placeholder="🔍 बँक नावानुसार शोधा..."
          value={searchBankName}
          onChange={(e) => setSearchBankName(e.target.value)}
          className="bank-search-input"
        />
        {searchBankName && (
          <button
            className="bank-search-clear"
            onClick={() => setSearchBankName("")}
          >
            ✕
          </button>
        )}
      </div>

      {/* FORM */}
      {showForm && (
        <form onSubmit={handleSubmit} className="bank-form">
          <div className="bank-form-grid">
            <div className="bank-field">
              <label>
                फंडाचे नाव <span className="bank-required">*</span>
              </label>
              <select
                name="fundName"
                value={formData.fundName}
                onChange={handleChange}
                className="bank-input bank-select"
                required
              >
                <option value="">-- निधि निवडा --</option>
                {funds.map((fund) => (
                  <option key={fund} value={fund}>
                    {fund}
                  </option>
                ))}
              </select>
            </div>

            <div className="bank-field">
              <label>
                बँकेचे नाव <span className="bank-required">*</span>
              </label>
              <select
                name="bankName"
                value={formData.bankName}
                onChange={handleChange}
                className="bank-input bank-select"
                required
              >
                <option value="">-- बँक निवडा --</option>
                {bankOptions.map((bank) => (
                  <option key={bank} value={bank}>
                    {bank}
                  </option>
                ))}
              </select>
            </div>

            <div className="bank-field">
              <label>शाखेचे नाव</label>
              <select
                name="branchName"
                value={formData.branchName}
                onChange={handleChange}
                className="bank-input bank-select"
              >
                <option value="">-- शाखा निवडा --</option>
                {branchOptions.map((branch) => (
                  <option key={branch} value={branch}>
                    {branch}
                  </option>
                ))}
              </select>
            </div>

            <div className="bank-field">
              <label>
                खाते प्रकार <span className="bank-required">*</span>
              </label>
              <select
                name="accountType"
                value={formData.accountType}
                onChange={handleChange}
                className="bank-input bank-select"
                required
              >
                <option value="">-- खाते प्रकार निवडा --</option>
                {accountTypeOptions.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            <div className="bank-field">
              <label>खाते क्रमांक</label>
              <input
                type="text"
                name="accountNumber"
                placeholder="खाते क्रमांक"
                value={formData.accountNumber}
                onChange={handleChange}
                className="bank-input"
              />
            </div>

            <div className="bank-field">
              <label>IFSC कोड</label>
              <input
                type="text"
                name="ifscCode"
                placeholder="IFSC कोड"
                value={formData.ifscCode}
                onChange={handleChange}
                className="bank-input"
              />
            </div>

            <div className="bank-field">
              <label>पत्ता (Address)</label>
              <textarea
                name="address"
                placeholder="बँक शाखेचा पत्ता"
                value={formData.address}
                onChange={handleChange}
                className="bank-input"
                rows="3"
                style={{ resize: "vertical" }}
              />
            </div>

            <div className="bank-field">
              <label>प्रारंभिक शिल्लक</label>
              <input
                type="number"
                name="openingBalance"
                placeholder="प्रारंभिक शिल्लक"
                value={formData.openingBalance}
                onChange={handleChange}
                className="bank-input"
                step="0.01"
              />
            </div>
          </div>

          <div className="bank-form-actions">
            <button type="submit" className="bank-btn-save">
              💾 जतन करा
            </button>
            <button
              type="button"
              onClick={handleReset}
              className="bank-btn-reset"
            >
              🔄 रीसेट करा
            </button>
          </div>
        </form>
      )}

      {/* STATISTICS */}
      <div className="bank-stats">
        <div className="bank-stat-item">
          <span>एकूण बँक:</span>
          <strong>{banks.length}</strong>
        </div>
        {searchBankName && (
          <div className="bank-stat-item">
            <span>शोध परिणाम:</span>
            <strong>
              {banks.filter((bank) =>
                bank.bankName
                  .toLowerCase()
                  .includes(searchBankName.toLowerCase())
              ).length}
            </strong>
          </div>
        )}
      </div>

      {/* TABLE */}
      <div className="bank-table-wrapper">
        <table className="bank-table">
          <thead>
            <tr>
              <th>क्र.</th>
              <th>फंड नाव</th>
              <th>बँक नाव</th>
              <th>शाखा</th>
              <th>खाते प्रकार</th>
              <th>खाते क्र.</th>
              <th>IFSC</th>
              <th>पत्ता</th>
              <th>शिल्लक</th>
              <th>क्रिया</th>
            </tr>
          </thead>

          <tbody>
            {banks.length === 0 ? (
              <tr>
                <td colSpan="10" className="bank-no-data">
                  📭 कोणतीही बँक नोंद उपलब्ध नाही
                </td>
              </tr>
            ) : searchBankName &&
              !banks.some((bank) =>
                bank.bankName
                  .toLowerCase()
                  .includes(searchBankName.toLowerCase())
              ) ? (
              <tr>
                <td colSpan="9" className="bank-no-data">
                  🔍 "{searchBankName}" साठी कोणत्याही बँक सापडले नाही
                </td>
              </tr>
            ) : (
              banks
                .filter((bank) =>
                  bank.bankName
                    .toLowerCase()
                    .includes(searchBankName.toLowerCase())
                )
                .map((bank, index) => (
                  <tr key={bank.id}>
                    <td>{index + 1}</td>
                    <td>{bank.fundName}</td>
                    <td>{bank.bankName}</td>
                    <td>{bank.branchName}</td>
                    <td>{bank.accountType}</td>
                    <td>{bank.accountNumber}</td>
                    <td>{bank.ifscCode}</td>
                    <td title={bank.address} className="bank-address-cell">{bank.address || "-"}</td>
                    <td>₹ {parseFloat(bank.openingBalance || 0).toFixed(2)}</td>
                    <td>
                      <button
                        onClick={() => deleteBank(bank.id)}
                        className="bank-btn-delete"
                      >
                        🗑️ हटवा
                      </button>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>

      {/* VARSHIK SHILAK FORM */}
      <VarshikShillakForm funds={funds} banks={banks} />

      {/* JAMA KARNARYACHI MAHITI */}
      <JamaKarnaryachiMahiti />

      {/* CHEQUE BOOK MAHITI */}
      <ChequeBookMahiti />

      {/* BANK TO BANK TRANSFER */}
      <BankToBankTransfer />
    </div>
  );
};

export default BankMahiti;
